//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'

export default {
  components: {
    DialogConfirmPick: () => import('../DialogConfirmPick/index.vue'),
    DialogSelectDealer: () => import('../DialogSelectDealer/index.vue')
  },
  props: {
    tableData: {
      default: () => []
    },
    loading: {
      default: false
    }
  },
  data: function () {
    return {
      rowData: {},
      dealerList: [],
      pickData: [],
      items:[],
      detailDialogVisible: false,
      successDialogVisible: false,
      selectDealerDialogVisible: false
    }
  },
  created () {
  },
  watch:{
    tableData(newValue){
      newValue.forEach(e=>{
        if(e.dealerJson && typeof(e.dealerJson) === 'string')
        e.dealerJson = JSON.parse(e.dealerJson)
      })
      newValue.forEach(e=>{
        if(e.dealerJson && typeof(e.dealerJson) === 'object'){
          e.dealerJson.forEach(jsonSub=>{
            for(let i = 0;i< e.dealerList.length;i++){
              if(e.dealerList[i].dealerId === jsonSub.dealerId){
                console.log(jsonSub)
                this.handleAddDealer(e,e.dealerList[i],jsonSub.count)       
                break         
              }
            }
          })
        }
      })
    }
  },
  mounted () {
    this.$axios.get('/mtea/store/admin/dealer/list', { params: {} }).then(res => {
        this.dealerList = res
        console.log(this.dealerList)
    }).finally(() => {
    })
  },
  methods: {
    handleUpdateDealer (row) {
      let data = _.extend({}, _.pick(row.data, 'dealerId'))
      data.items = [
        {gid: row.data.goodsId, cost_price: row.data.goodsInfo.price}
      ]
      data.items = JSON.stringify(data.items)
      // console.log('data', data)
      this.$axios.post('/mtea/store/admin/dealer/relation/batch', data).then(res => {
        row.state.showPopover = false
        this.$emit('submit')
      }).finally(() => {

      })
    },
    handleSelectDealer(item, selected, dealerId) {
      let dealerInfo = _.findWhere(item.dealerList, {dealerId:  dealerId})
      _.extend(selected, {dealerInfo: dealerInfo, selectedDealerId: dealerInfo.dealerId, selectedLocationId: ((dealerInfo.locations && dealerInfo.locations.length > 0) ? dealerInfo.locations[0].locationId : undefined)})
    },
    handleDeleteDealer(item, selected){
      let index = _.indexOf(item.selectedDealer, selected)
      item.selectedDealer.splice(index, 1)
    },
    handleAddDealer(item, selected,count=-1){
      console.log(item,selected)
      let dealerInfo = _.clone(selected)
      let selectedNum = _.reduce(item.selectedDealer, (memo, item) => {
        return memo + item.selectedNum
      }, 0)
      let surplusNumber = item.surplusNumber - selectedNum
      let d = _.extend({selectedDealerId:selected.dealerId, selectedLocationId: undefined, dealerInfo: dealerInfo, selectedNum: (surplusNumber < 0 ? 0 : surplusNumber)})
      console.log(dealerInfo,dealerInfo.locations,!dealerInfo.locations)
      // if(!dealerInfo.locations)dealerInfo.locations = selected.locations
      if(dealerInfo.locations && dealerInfo.locations.length > 0) {
        d.selectedLocationId = dealerInfo.locations[0].locationId
      }
      // console.log('item', item, 'selected', selected, 'd', d)
      console.log(JSON.stringify(d),count)
      if(count !== -1)d.selectedNum = count
      item.selectedDealer.push(d)
    },
    handleCreatePick () {
      let items = []
      let dealerObj = {}
      for (let i = 0; i < this.tableData.length; i++) {
        let t = this.tableData[i]
        let selectedNum = _.reduce(t.selectedDealer, (memo, item) => {
          return memo + item.selectedNum
        }, 0)
        if (selectedNum > t.surplusNumber) {
          this.$notify.error({
            title: '系统提示',
            message: `'${t.goodsInfo.name}'的取货数量大于了订单数量!`
          })
          return
        }
        let o = {}
        _.each(t.selectedDealer, (m) => {
          let k = `${m.selectedDealerId}-${m.selectedLocationId}-${m.selectedNum}`
          if (o[k]) {
            o[k].selectedNum += m.selectedNum
          } else {
            o[k] = m
          }
        })
        let selectedDealer = _.values(o)
        for(var j = 0; j < selectedDealer.length; j++){
          var n = selectedDealer[j];
          if (n.selectedNum > 0) {
            if (n.selectedLocationId === undefined) {
              this.$notify.error({
                title: '系统提示',
                message: '取货地址不能为空'
              })
              return
            }
            if (n.dealerInfo === undefined || n.dealerInfo.dealerId === undefined) {
              this.$notify.error({
                title: '系统提示',
                message: '经销商不能为空'
              })
              return
            }
            let item = _.extend({num: n.selectedNum, locationId: n.selectedLocationId}, _.pick(t.goodsInfo, 'goodsId'), _.pick(n.dealerInfo, 'dealerId'))
            let f = _.findWhere(n.dealerInfo.locations, {locationId: n.selectedLocationId})
            if (f !== undefined && f.pointId === undefined) {
              this.$notify.error({
                title: '系统提示',
                message: '取货点不能为空'
              })
              return
            }
            item.pointId = f.pointId
            items.push(item)
            let dealerInfo = t.dealerInfo
            if (!dealerObj[n.dealerInfo.dealerId]) {
              dealerObj[n.dealerInfo.dealerId] = _.extend({items: []}, n.dealerInfo)
            }
            dealerObj[n.dealerInfo.dealerId].items.push(_.extend({}, n, _.pick(t, 'goodsInfo')))

          }
        }
      }
      this.items = items
      // console.log('items', items)
      /**/
      let pickData = _.values(dealerObj)
      _.each(pickData, (t, i, l) => {
        t.totalAmount = _.reduce(t.items, (memo, item) => {
          return memo + item.goodsInfo.price * item.selectedNum
        }, 0)
      })
      this.pickData = pickData
      this.detailDialogVisible = true

    }
  }
}
